import { useTheme } from "@mui/material/styles";
import { useMatchQuery } from "./useMatchQuery.js";
const useIsDesktop = ()=>{
    const theme = useTheme();
    return useMatchQuery(theme.breakpoints.up('md'));
};
export { useIsDesktop };
